import { render, staticRenderFns } from "./IntegralGoodsList.vue?vue&type=template&id=f67c1f6c&scoped=true&"
import script from "./IntegralGoodsList.vue?vue&type=script&lang=js&"
export * from "./IntegralGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./IntegralGoodsList.vue?vue&type=style&index=0&id=f67c1f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67c1f6c",
  null
  
)

export default component.exports